maxPlayButton = {};

maxPlayButton.create = function () {
  var button = new PIXI.Container();

  button._isPromotion = false;

  InputHelpers.addGenerics(button);
  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);

  button.canShow = function () {
    if (checkForUndefined(this.gameConfig)) return false;

    return !gameController.inFreespins;
  };

  button.canEnable = function () {
    if (checkForUndefined(this.gameConfig)) return false;

    var allow = this._flags.canSpin && !this._flags.autoplayStarted && !this._flags.modal.active && !this._isPromotion;

    button.buttonContainer.alpha = allow ? 1 : 0.5;

    button.idleAnim.visible =
      this._flags.canSpin &&
      !gameController.maxPlayActive &&
      !autoplayManager.isAutoplayEnabled() &&
      !this._flags.modal.active;

    return allow;
  };

  button.onConfig = function (config) {
    this.gameConfig = config;
  };

  button.isAllowed = function () {
    //return gdk.getPlatformAllowsGamble();
  };

  button.setupResources = function () {
    let self = this;
    messageBus.subscribe("spinner:GameConfigEvent", function () {
      self.onLayoutComplete();
    });

    messageBus.subscribe("spinner:GameConfigEvent", button.onConfig.bind(button));
    messageBus.subscribe("common:PromotionStarted", button.promotionStarted.bind(button));
    messageBus.subscribe("common:PromotionEnded", button.promotionEnded.bind(button));
  };

  button.onLayoutComplete = function () {
    button.modeOn = resourceManager.get("buttonContainer:buttonBar:maxPlayButton:button:buttonOn");
    button.modeOff = resourceManager.get("buttonContainer:buttonBar:maxPlayButton:button:buttonOff");
    button.buttonContainer = resourceManager.get("buttonContainer:buttonBar:maxPlayButton");

    button.modeOff.visible = false;

    button.modes = [button.modeOn, button.modeOff];

    button.idleAnim = resourceManager.createObject(
      "movie",
      "maxPlayIdle",
      "buttonContainer:buttonBar:maxPlayButton:button",
      {
        definition: "maxPlay",
        anchor: 0.5,
      }
    );
    button.idleAnim.loop = true;
    button.idleAnim.gotoAndPlay(0);
  };

  button.setRecovery = function () {};

  button.promotionStarted = function () {
    this._isPromotion = true;
  };

  button.promotionEnded = function () {
    this._isPromotion = false;
  };

  button.onPressedCallback = function () {
    button.switchMode();

    if (!gameController.maxPlayActive) {
      soundManager.play("buttonPressed");
    }

    messageBus.post("maxPlay", { active: gameController.maxPlayActive });
  };

  button.switchMode = function () {
    gameController.maxPlayActive = !gameController.maxPlayActive;

    button.modes[+gameController.maxPlayActive].visible = true;
    button.modes[+!gameController.maxPlayActive].visible = false;

    button.idleAnim.visible = !gameController.maxPlayActive;
  };

  return button;
};

maxPlayButton.initialise = function (json, object) {
  object.setupResources();
};

maxPlayButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "maxPlayButton",
  maxPlayButton.create,
  maxPlayButton.initialise,
  maxPlayButton.getFilesRequired
);
